import React from 'react'

const Required = () => {
  return (
    <>
    <sup className='invalid danger'>*</sup>
    </>
  )
}
export default Required;